<template>
  <div id="login" class="flex column wrap justify-center grow-1">
    <form @keypress.enter.prevent class="form flex column grow-1 align-start align-self-center justify-center justify-flex-start-sm">
      <h1>Iniciar sesión: Línea Exprés</h1>
      <div class="form-group">
        <input
          @keypress.enter="submitLogin"
          type="email"
          id="email"
          name="email"
          placeholder="Correo"
          class="text-input"
          v-model="email"
          autofocus
          required
        />
        <span v-if="this.errors.email.length" class="error">{{ this.errors.email[0] }}</span>
      </div>
      <div class="form-group">
        <input
          @keypress.enter="submitLogin"
          type="password"
          id="password"
          name="password"
          placeholder="Contraseña"
          class="text-input"
          v-model="password"
          required
        />
      </div>
      <div v-if="this.showSentri" class="form-group">
        <div class="sentri-input">
          <input
            @keypress.enter="submitLogin"
            type="text"
            id="sentri"
            name="sentri"
            placeholder="Sentri/Global Entry"
            class="text-input"
            v-model="sentri"
          />
          <button class="btn" @click.prevent="showModalSentri = true">?</button>
        </div>
        <span v-if="this.errors.sentri.length" class="error">{{ this.errors.sentri[0] }}</span>
      </div>
      <div class="flex justify-space-evenly dspl-inline-grid-m dspl-inline-grid-sm justify-stretch-sm login-buttons">
        <button class="btn" @click.prevent="submitLogin">Ingresar</button>
        <button class="btn" @click.prevent="routeToCE">Acceso a Control Empresarial</button>
      </div>
    </form>
    <nav class="flex justify-space-between align-self-center nav">
      <router-link to="/create-account" class="btn" tag="button">
        Registra tu cuenta con nosotros
      </router-link>
      <router-link to="/reset-password-request" class="btn" tag="button">
        ¿Olvidaste tu contraseña?
      </router-link>
      <router-link to="/terms-and-conditions" class="btn" tag="button">
        Términos y Condiciones
      </router-link>
    </nav>
    <InformationModal
      @confirm="showModalSentri = false"
      :active="showModalSentri"
      title="¿Dónde encuentro mi Sentri?"
    >
      <template #content>
        <img src="@/assets/images/sentri.png">
      </template>
    </InformationModal>
    <ErrorModal
      @confirm="confirmModalError"
      :active="showModalError"
      message="Revisa que tus credenciales de acceso sean correctas, si es tu primera vez iniciando sesión intenta nuevamente con tu sentri"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ErrorModal from '@/components/ErrorModal'
import InformationModal from '@/components/InformationModal'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      sentri: '',
      password: '',
      showModalSentri: false,
      showModalError: false,
      showSentri: false,
      errors: {
        email: [],
        sentri: []
      }
    }
  },
  components: {
    ErrorModal,
    InformationModal
  },
  methods: {
    ...mapActions('user', [
      'login'
    ]),
    ...mapActions('products', [
      'getCrossingProductsList',
      'getAnnualityProductsList'
    ]),
    routeToCE () {
      this.$router.push('/ce-login')
    },
    routeToGuestRecharge () {
      this.$router.push('/telepeaje_tag')
    },
    routeToGuestCardRecharge () {
      this.$router.push('/telepeaje_card')
    },
    cleanErrors () {
      this.errors = {
        email: [],
        sentri: []
      }
    },
    confirmModalError () {
      if (this.showSentri === false) {
        this.showSentri = true
      }
      this.showModalError = false
    },
    submitLogin: function () {
      const emailRegexp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/

      this.cleanErrors()

      if (!emailRegexp.test(this.email)) {
        this.errors = { ...this.errors, email: ['El email debe tener un formato válido'] }
      }

      if (!this.errors.email.length && !this.errors.sentri.length) {
        this.sendData()
      }
    },
    sendData: function () {
      const data = { email: this.email, sentri: this.sentri, password: this.password }
      this.login(data).then(() => {
        if (this.$store.state.user.terms_accepted) {
          this.getAnnualityProductsList()
          this.getCrossingProductsList()
          this.$router.push('/vehicles')
        } else {
          this.$router.push('/terms-and-conditions')
        }
      }).catch((_) => {
        this.showModalError = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#login {
  height: 100vh;
}

.form {
  width: 50%;
}

.text-input {
  font-size: 1rem;
  padding: 0.8rem;
  border-radius: 20px;
  border-width: 0;
  width: 100%;

  &:focus {
    outline-width: 0;
  }
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

.color-text{
  color: $blue;
  text-decoration: none;
}

.login-buttons {
  width: 100%;
}

.sentri-input {
  width: 100%;
  position: relative;

  .btn {
    position: absolute;
    top: 0;
    right: -1rem;
    margin: 6px 0;
  }
}

.error {
  font-size: 0.75rem;
  color: $red;
  margin: 0 0.5rem;
}

.form-group {
  width: 100%;
  margin: 0.75rem 0;
  text-align: left;
}

.nav {
  margin-bottom: 1rem;
  width: 90%;
}

.fakebtn-container {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.fakebtn {
  max-height: 150px;
}
.fakebtn-label {
  font-weight: bold;
  cursor: pointer;
}

@media screen and (max-width: 960px) {
  button.btn {
    font-size: 1rem;
  }
  .form{
    width: 80%;
  }
  .text-input{
    width: 90%;
  }
  .fakebtn {
    max-height: 200px;
  }
}

@media screen and (max-width: 480px) {
  #login {
    height: 100%;
    min-height: 550px;
  }

  .form{
    width: 70%;
    margin: 5% 0 5% 0;
  }

  .nav {
    bottom: 5%;
  }
}
</style>
